module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('a', {
    attrs: {
      "id": "ad_card_1"
    }
  }), _c('p', {
    staticClass: "ach"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ALSO BY")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OBERT")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELLENGA")])]), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("The Sixteen Pleasures")])]), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("The Fall of a Sparrow")])]), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("Blues Lessons")])]), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("Philosophy Made Simple")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-100e2aa5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ItalianLover_ad_card_1.vue
// module id = 66
// module chunks = 0